import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import CentredContentContainer from "../Widgets/CentredContentContainer"
import theme from "../../styles/theme"

class DividerSlice extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <CentredContentContainer>
        <section className={classes.divider}></section>
      </CentredContentContainer>
    )
  }
}

export default injectSheet(
  {
    divider: {
      borderTop: `1px solid ${theme.colors.faintGrey}`,
      marginBottom: theme.spacing.large,
      [theme.breakpoint('tablet')]: {
        marginBottom: theme.spacing.huge
      }
    }
  }
)(DividerSlice)


// WEBPACK FOOTER //
// ./src/components/Article/DividerSlice.js